module.exports = __webpack_public_path__ + "img/aio_cover_a.770d91b6.png";